import { c6Colors, makeStyles } from '@c6bank/diamond'

export default makeStyles(theme => ({
  icon: {
    color: c6Colors.red,
    fontSize: theme.typography.pxToRem(98),
  },
}))
